import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: JSON.parse(localStorage.getItem('user_profile') || 'null'),
  token: localStorage.getItem('auth_token') || null,
  isAuthenticated: !!localStorage.getItem('auth_token'),
  permissions: JSON.parse(localStorage.getItem('user_permissions') || 'null'),
  centerId: localStorage.getItem('user_center_id') || null,
  isSuperAdmin: localStorage.getItem('is_super_admin') === 'true' || ['SUPER_ADMIN', 'ADMIN'].includes(localStorage.getItem('user_role')),
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.permissions = action.payload.permissions || null;
      state.centerId = action.payload.centerId || null;
      state.isSuperAdmin = action.payload.isSuperAdmin || false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.permissions = null;
      state.centerId = null;
      state.isSuperAdmin = false;
      state.error = null;
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_permissions');
      localStorage.removeItem('user_center_id');
      localStorage.removeItem('is_super_admin');
      localStorage.removeItem('user_role');
      localStorage.removeItem('user_profile');
      sessionStorage.removeItem('isLoggedIn');
    },
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.permissions = action.payload.permissions || {};
      state.centerId = action.payload.centerId || null;
      state.isSuperAdmin = action.payload.isSuperAdmin || false;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  clearError,
  setUser,
  setLoading,
} = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;
export const selectPermissions = (state) => state.auth.permissions;
export const selectCenterId = (state) => state.auth.centerId;
export const selectIsSuperAdmin = (state) => state.auth.isSuperAdmin;

export default authSlice.reducer;
